import { getCountries, getCountryCallingCode } from "libphonenumber-js";

export interface CountryOption {
  name: string;
  iso2: string;
  dialCode: string;
  flag: string;
}

const FLAG_OFFSET = 0x1f1e6;

const isoToFlag = (iso2: string): string => {
  return iso2
    .toUpperCase()
    .split("")
    .map((char) => String.fromCodePoint(FLAG_OFFSET + char.charCodeAt(0) - 65))
    .join("");
};

export const buildCountryOptions = (locale: string = "en"): CountryOption[] => {
  const displayNames =
    typeof Intl !== "undefined" && (Intl as any).DisplayNames
      ? new (Intl as any).DisplayNames([locale], { type: "region" })
      : null;

  return getCountries()
    .map((iso2) => {
      const name = displayNames?.of(iso2) || iso2;
      const dialCode = `+${getCountryCallingCode(iso2)}`;
      return {
        name,
        iso2,
        dialCode,
        flag: isoToFlag(iso2),
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
};


export const resetCountrySelectPanelScroll = (): void => {
  document.querySelectorAll(".mat-mdc-select-panel.country-select-panel").forEach((panel) => {
    (panel as HTMLElement).scrollTop = 0;
  });
};

export const handleCountrySelectPanelOpened = (
  opened: boolean,
  clearSearch?: () => void
): void => {
  if (!opened) {
    return;
  }
  clearSearch?.();
  resetCountrySelectPanelScroll();
  setTimeout(resetCountrySelectPanelScroll, 0);
  requestAnimationFrame(() => {
    resetCountrySelectPanelScroll();
    requestAnimationFrame(resetCountrySelectPanelScroll);
  });
};
